/**
 * Dictionary of keys used to track loading states across the app.
 * When loading is triggered, the base store assigns the key to store.loadingKeys
 * with a count against each key (based on how many requests are loading)
 */
export default Object.freeze({
  defaultLoadingKey: 'defaultLoadingKey',
  forms: {
    loadingFormSubmission: 'loadingFormSubmission',
  },
})
